import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {setUserData} from "../../store/actions/userLoginActions";
import {Upload} from "antd";

import {toast} from "react-toastify";
import ServiceUser from '../../services/users';

import UserIcon from "../icons/userIcon";
import PhotoIcon from "../icons/photoIcon";
import jwt from "jsonwebtoken";
import Http from "../utils/Http";
import Message from '../../commons/utils/message'


export default props => {
    const { userData } = useSelector(state => state.userLogin);
    const dispatch = useDispatch();

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };



    async function savePhoto(dataPhoto, photoBase64) {
        dispatch(setUserData({...userData, picture: photoBase64}))
       let resp = await ServiceUser.updatePhoto(dataPhoto);
       const error=resp.data.response.error;
        if (!error) {
            Message.showSuccess(resp.data.response.message);
            let token = localStorage.getItem("token");
            Http.get(`/token-xchange?application_id=${2}&token=${token}`).then(resp => {
                if (!resp.data.response.error) {
                    const token = resp.data.data.access_token
                    const tokenData = jwt.decode(token);
                    localStorage.setItem('token', token);
                }
              
            }).catch(err => {
                Message.showError("Error ao atualizar token");
            });


          
        }else{
            Message.showError(error.message);
        }
    }




    function getImageBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function beforeUploadPhoto(file) {
        
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            Message.showInfo("Você só pode enviar arquivos JPG / PNG!")
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            Message.showInfo("A imagem é muito grande. As imagens podem ter no máximo 5 MB.");
        }
        return isJpgOrPng && isLt2M;
    }

    function onChangePhoto(info) {
     
        if (info.file.status === 'done') {

            const data = new FormData();
            data.append('image', info.file.originFileObj);
            data.append('id', userData.id)
         
            getImageBase64(info.file.originFileObj, base64Str => {
                savePhoto(data, base64Str)
            });
        } else if (info.file.status === 'error') {
          
            toast.error("Erros ao alterar foto");
        }
    }

    function renderUploadButton() {
        if (userData.picture) {
            return (
                <img
                    src={userData.picture}
                    style={{
                        objectFit: "cover",
                        borderRadius: "24px",
                        margin: "auto",
                        width: 100,
                        height: 100
                    }}
                    alt="Imagem do usuário"/>
            )
        } else {
            return (
                <span style={{
                    fontSize: 52,
                    bottom: 5,
                    position: "relative"
                }}>
                        <UserIcon/>
                </span>
            )
        }
    }

    return (
        <>
            <Upload
                name="file"
                className="avatar-uploader"
                showUploadList={false}
                customRequest={dummyRequest}
                beforeUpload={beforeUploadPhoto}
                onChange={onChangePhoto}
            >
                <div className="user-avatar" style={{
                    width: props.width ? props.width : 100,
                    height: props.height ? props.height : 100,
                }}>
                    <div className="user-default-image-tooltiptext">
                        <div style={{ top: 20, position: "relative"}}>
                            <span style={{fontSize: 20}}><PhotoIcon/></span>
                            <br/>
                            <span>Alterar</span>
                        </div>
                    </div>
                    {renderUploadButton()}
                </div>
            </Upload>
        </>
    )


                

}
